(function ($) {
    if ($('section.gallery-slider').length) {

        /* 01 */
        /*
        $('.swiper.gallery').each(function(index, element) {

            var regularGalleryElement = element;
            var regularGalleryPaginationElement = $(this).parent().parent().parent().find('.swiper-pagination-unique-2')[0];
            var regularGalleryNextElement = $(this).parent().parent().parent().find('.swiper-button-next-unique-2')[0];
            var regularGalleryPrevElement = $(this).parent().parent().parent().find('.swiper-button-prev-unique-2')[0];

            var swiperGallery = new Swiper( regularGalleryElement, {
                pagination: {
                    el: regularGalleryPaginationElement,
                    type: 'progressbar',
                },
                navigation: {
                    nextEl: regularGalleryNextElement,
                    prevEl: regularGalleryPrevElement,
                },
                slidesPerView: 'auto',
                spaceBetween: 20,
                watchOverflow: true,
                //slidesPerGroupAuto: true,
                slidesPerGroup: 2,
                preloadImages: true,
                on: {
                    init: function (e) {
                        // https://github.com/nolimits4web/swiper/issues/4052
                        // https://v8.swiperjs.com/swiper-api#events
                        setTimeout(() => {
                            this.update();
                        }, 10);
                    },
                }
            });

        });
        */

        /*
        var swiperFFF = new Swiper(".horizontalGallery", {
            slidesPerView: "auto",
            spaceBetween: 20,
            pagination: {
                el: $(this).closest('.gallery-slider').find('.swiper-pagination-unique-2')[0],
                type: 'progressbar',
            },
            navigation: {
                nextEl: '.swiper-button-next-unique-2',
                prevEl: '.swiper-button-prev-unique-2',
            }
        });
        */


        $('.horizontalGallery').each(function(index, element) {

            var regularGalleryElement = element;
            var regularGalleryPaginationElement = $(this).closest('.gallery-slider').find('.swiper-pagination-unique-2')[0];
            var regularGalleryNextElement = $(this).closest('.gallery-slider').find('.swiper-button-next-unique-2')[0];
            var regularGalleryPrevElement = $(this).closest('.gallery-slider').find('.swiper-button-prev-unique-2')[0];

            var swiperFFF = new Swiper( regularGalleryElement, {
                slidesPerView: "auto",
                spaceBetween: 20,
                pagination: {
                    el: regularGalleryPaginationElement,
                    type: 'progressbar',
                },
                navigation: {
                    nextEl: regularGalleryNextElement,
                    prevEl: regularGalleryPrevElement,
                }
            });


        });


        /* 02 */
        $('.swiper.gallery-swiper2').each(function(index, element) {

            var modalSliderGalleryElement = element;
            var modalSliderGalleryElementPaginationElement = $(this).find('.swiper-pagination')[0];
            var modalSliderGalleryElementNextElement = $(this).find('.swiper-button-next')[0];
            var modalSliderGalleryElementPrevElement = $(this).find('.swiper-button-prev')[0];
            var targetGalleryRawData = $(this).data('gallery-constant');
            var gallery = window[targetGalleryRawData];

            const gallerySwiper2 = new Swiper( modalSliderGalleryElement, {
                keyboard: {
                    enabled: true,
                    onlyInViewport:true,
                },
                slidesPerView: 1,
                centeredSlides: false,
                pagination: {
                    el: modalSliderGalleryElementPaginationElement,
                    type: 'fraction',
                },
                navigation: {
                    nextEl: modalSliderGalleryElementNextElement,
                    prevEl: modalSliderGalleryElementPrevElement,
                },
                allowTouchMove: false,
                addSlidesBefore: 2,
                addSlidesAfter: 3,
                virtual: {
                    slides: (function() {
                        var slides = [];
                        for (var i = 0; i < gallery.length; i += 1) {
                            if( gallery[i].caption) {
                                slides.push(
                                    '<div class="content" data-hash="gallery-slider-'+ gallery[i].id +'" data-gallery="'+gallery[i].id+'"><img src="'+ gallery[i].image + '"/></div>'
                                    +'<p class="caption">'+
                                    gallery[i].caption+'</p>'
                                );
                            } else {
                                slides.push(
                                    '<div class="content" data-hash="gallery-slider-'+ gallery[i].id +'" data-gallery="'+gallery[i].id+'"><img src="'+ gallery[i].image + '"/></div>'
                                );
                            }
                        }
                        return slides;
                    })()
                }

            });

            gallerySwiper2.on('slideChange', function () {
                if(gallerySwiper2.visibleSlides) {
                    window.location.hash = `gallery-slider-${gallerySwiper2.visibleSlides.find('.content').attr('data-gallery')}`
                }
            });

            $(window).on('hashchange', function() {
                if ( !window.location.hash ) {
                    $('.gallery-modal').removeClass('active');
                    $('body').removeClass('overflow-hidden');
                    $('body').removeClass('modal-open');
                } else {

                    var isModalOpen = $('.gallery-modal.gallery-slider-modal').hasClass('active');
                    if ( !isModalOpen ) {
                        const targetWorker = window.location.hash.split('gallery-slider-')[1];
                        if ( targetWorker ) {
                            $.each($(gallerySwiper2)[0].virtual.slides , function(index, val) {
                                if($(this).data('gallery') == targetWorker ) {
                                    gallerySwiper2.slideTo(index, 0);
                                }
                            });
                            window.location.hash = `gallery-slider-${targetWorker}`;
                            $('body').addClass('overflow-hidden');
                            $('body').addClass('modal-open');
                            $('.gallery-modal.gallery-slider-modal').addClass('active');
                        }
                    }
                }
            });

            if ( window.location.hash.includes("gallery-slider") ) {
                var targetIdClean = window.location.hash.replace("#", "");
                var targetModalToOpen = $('[data-gallery='+targetIdClean+']').data('target-modal');

                $('body').addClass('overflow-hidden');
                $('body').addClass('modal-open');
                //$('.gallery-modal.gallery-slider-modal').addClass('active');
                $('#'+targetModalToOpen).addClass('active');

                const targetWorker = window.location.hash.split("gallery-slider-")[1];
                $.each($(gallerySwiper2)[0].virtual.slides , function(index, val) {
                    if($(this).data('gallery') == targetWorker ) {
                        gallerySwiper2.slideTo(index, 0);
                    }
                });
            }

        });

        $('body').on('click', '.open-gallery-slider-modal', function( event ) {
            var targetGalleryModal = $(event.currentTarget).data('target-modal');
            if ( targetGalleryModal ) {
                $('#'+targetGalleryModal).addClass('active');
            } else {
                $('.gallery-modal.gallery-slider-modal').addClass('active');
            }

            $('body').addClass('overflow-hidden');
            $('body').addClass('modal-open');

            const targetWorker = $(this).data('worker');
            window.location.hash = `gallery-slider-${targetWorker}`;
        });

        $(document).on('keyup',function(evt) {
            if (evt.keyCode === 27) {
                $('.gallery-modal').removeClass('active');
                $('body').removeClass('overflow-hidden');
                $('body').removeClass('modal-open');
                window.history.pushState('', '/', window.location.pathname);
            }
        });

        $('body').on('click', '.gallery-modal.gallery-slider-modal .close-button', function() {
            $('.gallery-modal').removeClass('active');
            $('body').removeClass('overflow-hidden');
            $('body').removeClass('modal-open');
            window.history.pushState('', '/', window.location.pathname);
        });

    }

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
})(jQuery);
